<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div id="data-list-thumb-view" class="data-list-container">
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Cliente Contrato</h6>
              <v-select
                name="customer"
                v-model="customerSelected"
                :options="customersContract"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-validate="'required'"
              />
              <br />
              <span class="text-danger">{{ errors.first("customer") }}</span>
            </div>
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Nome Produto</h6>
              <h3 class="mb-2">{{ name }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Finalidade</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    color="primary"
                    v-model="finality"
                    vs-value="Locação"
                    >Locação</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    color="success"
                    v-model="finality"
                    vs-value="Revenda"
                    >Revenda</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Proprietário</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio color="primary" v-model="owner" vs-value="Copyjui"
                    >Copyjui</vs-radio
                  >
                </li>
                <li>
                  <vs-radio color="success" v-model="owner" vs-value="Prime"
                    >Prime</vs-radio
                  >
                </li>
              </ul>
            </div> 
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Número de Série</h6>
              <vs-input v-model="serialNumber" class="w-full" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Fornecedor</h6>
              <vs-input v-model="trademark" class="w-full" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Valor da Compra</h6>
              <vs-input
                class="w-full"
                v-model="price"
                v-currency="{ currency: 'BRL', locale: 'pt-br' }"
              />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">NF de Entrada</h6>
              <vs-input class="w-full" v-model="nf" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Data de Entrada</h6>
              <div>
                <datepicker
                  placeholder="Selecione a Data"
                  :language="languages['ptBR']"
                  format="dd/MM/yyyy"
                  v-model="entryDate"
                ></datepicker>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Local</h6>
              <vs-input class="w-full" v-model="sector" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Patrimônio</h6>
              <vs-input class="w-full" v-model="patrimony" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">NF de Saída</h6>
              <vs-input class="w-full" v-model="outgoingInvoice" />
            </div>
             <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Data de Saída</h6>
              <datepicker
                      placeholder="Selecione a Data"
                      :language="languages['ptBR']"
                      format="dd/MM/yyyy"
                      v-model="exitDate"
                    ></datepicker>   
            </div>
             <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Valor da Venda</h6>
              <vs-input
                class="w-full"
                v-model="saleValue"
                v-currency="{ currency: 'BRL', locale: 'pt-br' }"
              />
            </div>
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full  mt-5">
            <vs-list>
              <vs-list-header title="Histórico" color="danger"></vs-list-header>
              <div v-for="(item, index) of history" :key="index">
                <vs-list>
                  <vs-list-item 
                  :title="item.corporateName"
                  :subtitle="item.date"
                  >{{item.history}}
                  </vs-list-item>
                </vs-list>
              </div>
            </vs-list>
          </div>
        </div>
      </vx-card>

      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="idPermanentAsset">
            <vs-button class="float-left" color="danger" @click="deleteAsset"
              >Apagar</vs-button
            >
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-button class="float-right" color="success" @click="submit"
              >Salvar</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { baseApiUrl } from "@/global";
import router from "@/router";
import axios from "axios";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: { vSelect, Datepicker },
  props: {},
  data() {
    return {
      idPermanentAsset: null,
      languages: lang,
      customerSelected: [],
      product: null,
      name: null,
      price: null,
      nf: null,
      entryDate: null,
      outgoingInvoice: null,
      exitDate : null,
      saleValue : null,
      trademark: null,
      serialNumber: null,
      finality: "Locação",
      owner: "Copyjui",
      sector: "",
      patrimony: "",
      isMounted: false,
      customersContract: [],
      history: [],
    };
  },
  computed: {},
  methods: {
    async submit() {
      try {
        let data = {
          fk_idCustomer: this.customerSelected.id,
          idPermanentAsset: this.idPermanentAsset,
          idContractPermanentAsset:
            this.customerSelected.idContractPermanentAsset,
          finality: this.finality,
          owner: this.owner,
          nf: this.nf,
          entryDate: this.entryDate,
          outgoingInvoice: this.outgoingInvoice,
          serialNumber: this.serialNumber,
          price: this.price,
          trademark: this.trademark,
          sector: this.sector,
          patrimony: this.patrimony,
          saleValue: this.saleValue,
          exitDate: this.exitDate,
        };
        const responseAsset = await axios.post(
          `${baseApiUrl}/permanentAsset/updateAsset`,
          data
        );

        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (responseAsset.status == "200") {
          router.push("/ativos").catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Salvar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    async deleteAsset() {
      try {
        let data = {
          idPermanentAsset: this.idPermanentAsset,
        };
        const responseAsset = await axios.post(
          `${baseApiUrl}/permanentAsset/deletePermanentAsset`,
          data
        );

        this.$vs.loading.close();
        this.$vs.notify({
          title: "Apagado",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (responseAsset.status == "200") {
          router.push("/ativos").catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Apagar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
  }, 
  async created() {
    try {
      this.$vs.loading();
      const responseContracts = await axios.get(
        `${baseApiUrl}/permanentAsset/getContractsPermanentAsset`
      );
      const responseAsset = await axios.get(
        `${baseApiUrl}/permanentAsset/getPermanentAssetById/${this.$route.params.idPermanentAsset}`
      );
      let index = 0
      for (const element of responseContracts.data) {
        index++
        let customer = {
          fk_idCustomer : element.fk_idCustomer,
          id: index,
          label: `${element.idContractPermanentAsset} | ${element.corporateName}`,
          corporateName: element.corporateName,
          idContractPermanentAsset: element.idContractPermanentAsset,
        };
        this.customersContract.push(customer);
      }
      let customer = {
        fk_idCustomer : responseAsset.data[0].fk_idCustomer,
        id: responseAsset.data[0].fk_idCustomer,
        label: `${responseAsset.data[0].idContractPermanentAsset} | ${responseAsset.data[0].corporateName}`,
        corporateName: responseAsset.data[0].corporateName,
        idContractPermanentAsset:
          responseAsset.data[0].idContractPermanentAsset,
          
      };
      this.customerSelected = customer;
      this.idPermanentAsset = responseAsset.data[0].idPermanentAsset;
      this.name = responseAsset.data[0].name;
      this.finality = responseAsset.data[0].finality;
      this.owner = responseAsset.data[0].owner;
      this.nf = responseAsset.data[0].nf;
      this.entryDate = responseAsset.data[0].entryDate;
      this.outgoingInvoice = responseAsset.data[0].outgoingInvoice;
      this.serialNumber = responseAsset.data[0].serialNumber;
      this.price = responseAsset.data[0].price;
      this.trademark = responseAsset.data[0].trademark;
      this.sector = responseAsset.data[0].sector;
      this.patrimony = responseAsset.data[0].patrimony;
      this.saleValue = responseAsset.data[0].saleValue;
      this.exitDate = responseAsset.data[0].exitDate;
      this.history = responseAsset.data[1];
      this.$vs.loading.close();
    } catch (error) {
      console.log(error);
      this.$vs.notify({
        title: "Erro",
        text: "Não foi possivel carregar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });

      if (error.responseAsset.status == "400") {
        router.push(`/ativos`).catch(() => {});
      }
    } finally {
      this.$vs.loading.close();
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>